import React, { useState } from 'react';
import { Image as ImageIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { Carousel } from './Carousel';
export function Studio() {
  const [expanded, setExpanded] = useState(false);
  const studioItems = Array(6).fill(null).map((_, i) => <div key={i} className="h-[300px] bg-dark-3 flex items-center justify-center text-gold/20 relative overflow-hidden border border-gold/10 transition-colors duration-300 hover:border-gold/40" data-id="element-202">
        <ImageIcon size={48} data-id="element-203" />
      </div>);
  return <section id="studio" className="py-[70px] px-[25px] md:py-[80px] md:px-[40px] lg:py-[100px] lg:px-[60px] bg-dark" data-id="element-204">
      <FadeIn className="text-center mb-[70px]" data-id="element-205">
        <span className="inline-block text-[0.6rem] tracking-[6px] uppercase text-gold mb-[15px] font-semibold" data-id="element-206">
          El Espacio
        </span>
        <h2 className="font-cinzel text-[clamp(1.8rem,4vw,3rem)] text-white uppercase tracking-[4px] mb-5" data-id="element-207">
          Nuestro <span className="text-gold" data-id="element-208">Estudio</span>
        </h2>
        <div className="w-[60px] h-[2px] bg-gold mx-auto mb-5" data-id="element-209"></div>
        <p className="text-gray text-[0.95rem] leading-[1.8] max-w-[600px] mx-auto tracking-[0.5px]" data-id="element-210">
          Un ambiente diseñado para que te sientas cómodo, seguro y en manos de
          un verdadero profesional.
        </p>
      </FadeIn>
      <FadeIn className="max-w-[700px] mx-auto" data-id="element-211">
        <div className="relative border border-gold/15 overflow-hidden cursor-pointer group" onClick={() => setExpanded(!expanded)} data-id="element-212">
          <img src="https://cdn.magicpatterns.com/uploads/ePc6KQaZU4oVFn86uQ4VPu/IMG_6950.jpg" alt="SOLIDO TATTOO STUDIO - Fachada del estudio en Miami" className="w-full h-auto object-cover transition-transform duration-700 ease-out group-hover:scale-110" data-id="element-213" />
          <div className="absolute inset-0 bg-black/20 transition-opacity duration-500 group-hover:opacity-0" data-id="element-214"></div>
        </div>
      </FadeIn>
      {expanded && <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-6 cursor-pointer" onClick={() => setExpanded(false)} data-id="element-215">
          <img src="https://cdn.magicpatterns.com/uploads/ePc6KQaZU4oVFn86uQ4VPu/IMG_6950.jpg" alt="SOLIDO TATTOO STUDIO - Fachada del estudio en Miami" className="max-w-full max-h-[90vh] object-contain" data-id="element-216" />
          <span className="absolute top-6 right-8 text-white text-[0.7rem] tracking-[3px] uppercase opacity-60" data-id="element-217">
            Toca para cerrar
          </span>
        </div>}
    </section>;
}
export function Gallery() {
  const [expandedImg, setExpandedImg] = useState<string | null>(null);
  const galleryImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/uirTxc3yiB5Pwp86YwLQTy/IMG_7442_2.jpg',
    alt: 'Tatuaje realismo color - Dalí'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mWsy9uGVdeSvckgSMa7T9v/IMG_7144.jpg',
    alt: 'Tatuaje realismo color - Calavera'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nrCtjmU7E1RrAGXGNChg7Q/DSC00444.jpg',
    alt: 'Tatuaje realismo B&N - Dragón'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/hnZkJGJzfVi3Cs5GYhCYEW/Screenshot_2026-04-15_125628.png',
    alt: 'Tatuaje realismo color - Retrato'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/1jvknKq6ugQmHsuq37gYHs/Screenshot_2026-04-15_125703.png',
    alt: 'Tatuaje realismo B&N - Retrato'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/e8LKCGbTPuzrPGG8oCFqbC/Screenshot_2026-04-15_125722.png',
    alt: 'Tatuaje realismo B&N - Estatua griega'
  }];
  return <section id="gallery" className="py-[70px] px-[25px] md:py-[80px] md:px-[40px] lg:py-[100px] lg:px-[60px] bg-black" data-id="element-218">
      <FadeIn className="text-center mb-[70px]" data-id="element-219">
        <span className="inline-block text-[0.6rem] tracking-[6px] uppercase text-gold mb-[15px] font-semibold" data-id="element-220">
          El Trabajo
        </span>
        <h2 className="font-cinzel text-[clamp(1.8rem,4vw,3rem)] text-white uppercase tracking-[4px] mb-5" data-id="element-221">
          Galería de <span className="text-gold" data-id="element-222">Tatuajes</span>
        </h2>
        <div className="w-[60px] h-[2px] bg-gold mx-auto mb-5" data-id="element-223"></div>
        <p className="text-gray text-[0.95rem] leading-[1.8] max-w-[600px] mx-auto tracking-[0.5px]" data-id="element-224">
          Cada tatuaje es una historia. Aquí algunas de las piezas que han
          marcado piel y corazones en Miami.
        </p>
      </FadeIn>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-[3px] max-w-[1200px] mx-auto" data-id="element-225">
        {galleryImages.map((img, i) => <FadeIn key={i} delay={i * 0.1} className="relative overflow-hidden cursor-pointer group aspect-[3/4]" onClick={() => setExpandedImg(img.src)} data-id="element-226">
            <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" data-id="element-227" />
            <div className="absolute inset-0 bg-black/30 transition-opacity duration-500 group-hover:opacity-0" data-id="element-228"></div>
          </FadeIn>)}
      </div>

      {expandedImg && <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-6 cursor-pointer" onClick={() => setExpandedImg(null)} data-id="element-229">
          <img src={expandedImg} alt="Tatuaje ampliado" className="max-w-full max-h-[90vh] object-contain" data-id="element-230" />
          <span className="absolute top-6 right-8 text-white text-[0.7rem] tracking-[3px] uppercase opacity-60" data-id="element-231">
            Toca para cerrar
          </span>
        </div>}
    </section>;
}